import React from 'react'

const ShopCardSkeleton = (): JSX.Element => {
  return (
    <div className="overflow-hidden rounded-[24px] border border-gray-200 bg-white">

      {/* Offer Strip */}
      <div className="h-[24px] w-full bg-gray-200 animate-pulse">
        <div className="mx-3 h-4 w-[180px] animate-pulse rounded bg-gray-200" />
      </div>

      {/* Body */}
      <div className="flex p-4">
        {/* Logo */}
        <div className="h-[90px] w-[90px] animate-pulse rounded-[24px] bg-gray-200" />

        {/* Content */}
        <div className="ml-3 flex flex-1 flex-col justify-center">

          {/* Recommended */}
          <div className="mb-2 h-3 w-20 animate-pulse rounded bg-gray-200" />

          {/* Shop Name */}
          <div className="mb-3 h-5 w-[170px] animate-pulse rounded bg-gray-300" />

          {/* Rating + Delivery */}
          <div className="flex items-center gap-3">
            <div className="h-[22px] w-[40px] animate-pulse rounded-full bg-gray-200" />
            <div className="h-4 w-[120px] animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopCardSkeleton
